import Vue from 'vue';
import qs from 'qs';
import Modal, { ModalLinePrimary, ModalLineSecondary } from '@/components/Modal';
import { Airplane } from './Airplane';
import * as events from '@/metrix/events';
import { SeeBanerWidgetData, ModalDataBaner } from './types';
import './SeeBanerWidget.scss';
import { RootElementAttrsHolder } from '@/plugins/RootElementAttrsPlugin';

const defaults: ModalDataBaner = {
    action: null,
    metrix: {},
    imageUrl: null,
    borderRadius: null,
    maxWidth: null,
    maxHeight: null
};

export function createSeeBanerWidget(el: Element) {
    const rootAttrs = new RootElementAttrsHolder(el);

    return new Vue({
        el,
        name: 'SeeBanerWidget',
        rootAttrs,
        data(): SeeBanerWidgetData {
            return {
                active: false,
                modalDataBaner: {} as ModalDataBaner,
            };
        },

        methods: {
            show(modalDataBaner?: ModalDataBaner) {
                this.modalDataBaner = Object.assign({}, defaults, modalDataBaner || {});
                this.active = true;

                this.$metrix.$emit(
                    events.OPEN,
                    this.getMetrixPayload(this.modalDataBaner.metrix[events.OPEN])
                );
            },

            close() {

                console.log( "this hrefs", this );
                console.log( "events hrefs", events );

                this.$metrix.$emit(
                    events.CLOSE,
                    this.getMetrixPayload(this.modalDataBaner.metrix?.[events.CLOSE])
                );

                this.active = false;
            },

            hrefs() {

                console.log( "this hrefs", this );

                // @ts-ignore
                location.href=this.modalDataBaner.action;
            },

            getMetrixPayload(input: string) {
                const $form = {};
                return this.$enrichVars(input || {}, { $form });
            },

        },

        render(h) {
            return (
                <Modal
                    active={this.active}
                    swipeDownMaxDistance={150}
                    dopClass='seeBanerWidget'
                    modalDopClass='modalBanerWidget'
                    modalContainerDopClass='modalContainerDopClass'
                    onClose={() => this.close()}
                >
                    <div
                        onClick={() => this.hrefs()}
                        class='imgDesktop'
                        style={
                            {
                                'background-image': 'url('+this.modalDataBaner.imageUrl+')',
                                'border-radius': this.modalDataBaner.borderRadius,
                                'max-width': this.modalDataBaner.maxWidth,
                                'max-height': this.modalDataBaner.maxHeight
                            }
                        }

                    >
                        <span class='closeSee' onClick={(event: object) => {
                            // @ts-ignore
                            event.stopPropagation();
                            // @ts-ignore
                            event.preventDefault;
                            this.close()}}>&#10006;</span>
                    </div>
                </Modal>
            );
        },
    });
}
